import {atom, selector} from 'recoil';

export const userKey = 'current_user';
const date = new Date(new Date().setFullYear(new Date().getFullYear() + 1));

export const user = atom({
  key: 'user',
  default: null,
});

export const currentUserData = atom({
  key: 'currentUserData',
  default: null,
});

export const currentDateTime = atom({
  key: 'currentDateTime',
  default: date,
});

export const currentUser = selector({
  key: 'currentUser',
  get: ({get}) => get(user),
  set: ({set}, newValue) => {
    set(user, newValue);
    localStorage.setItem(userKey, JSON.stringify(newValue));
  },
});
